<!-- Zweck: Stellt die HTML-Struktur für shop warenkorb table component im Frontend bereit. -->
@if (title) {
<tr class="table_sectiontitle">
  <td [attr.colspan]="actions ? 13 : 10">
    {{title}}
  </td>
</tr>
}
@if (!ajax_mode && !(msvc.isMobile()|async)) {
  <tr class="thead">
    <th>#</th>
    @if (show_category) {
      <th>Kategorie</th>
    }
    @for (fieldname of active_fields; track fieldname) {
      <th class="header_{{fieldname}}">
        <view-field-label-render [fieldname]="fieldname" mode="table"></view-field-label-render>
      </th>
    }
    <th style="text-align: right; padding-right: 10px">Einzelpreis</th>
    <th style="width: 1%; text-align: center; cursor: help" matTooltip="Nachliefern">N</th>
    <th></th>
    <th style="text-align: right">Summe</th>
    @if (actions) {
      <th></th>
    }
    @if (actions) {
      <th style="width: 20px"></th>
    }
  </tr>
}
@if (positionen.length == 0) {
  <tr style="background-color: white">
    <td [attr.colspan]="actions ? (active_fields.length+6+(show_category?1:0)) : (active_fields.length+4+(show_category?1:0))" style="text-align: center;">
      <div style="vertical-align: middle; padding-top: 40px">
        <svg-icon style="width: 100px; height: 100px; font-size: 100px">traurig</svg-icon>
        <br>
        <div style="height: 100px; font-size: 16px; font-weight: bold">
          Der Warenkorb ist leer.
        </div>
      </div>
    </td>
  </tr>
}
<!-- AJAX Modus oder Mobile View -->
@if (ajax_mode || (msvc.isMobile() | async)) {
  @for (entry of positionen; track entry.id; let i = $index) {
    @if ((visiblePositions|async) === null || (visiblePositions|async)?.includes(entry.id)) {
    <tr>
      <td style="white-space: normal">
        <table style="width: 100%">
          <tr>
            <td style="background-color: rgba(0,0,0,.05)">
              <view-field-value-render [artikel]="entry.artikel" [view]="entry.artikel.view" [mode]="'table'" fieldname="pzn"
                                       [nowrap]="false" append_if_not_empty=" - "
                                       [viewcomp]="this"></view-field-value-render>
              <view-field-value-render [artikel]="entry.artikel" [mode]="'table'" [view]="entry.artikel.view" [nowrap]="false"
                                       [current_warenkorb]="warenkorb"
                                       [viewcomp]="this"
                                       fieldname="bezeichnung"></view-field-value-render>
              @if (cfg.domainconfig?.shop_aktionen_popup && entry.artikel.ArtikelHatAktion && cfg.showShopAktionen(entry.artikel)) {
                <artikel-aktionen-button [artikel]="entry.artikel" [view]="entry.artikel.view" [viewcomp]="this"
                  [popupMode]="true"></artikel-aktionen-button>
              }
              @if (positionVerfuegbarkeiten && positionVerfuegbarkeiten[entry.id]) {
                <shop-artikel-verfuegbarkeit-inline-info [data]="positionVerfuegbarkeiten[entry.id]"></shop-artikel-verfuegbarkeit-inline-info>
              }
              <div style="width: 20px; height: 20px; display: inline-block">
                @if (entry.dirty) {
                  <div matTooltip="Speichere...">
                    <mat-spinner [diameter]="20"></mat-spinner>
                  </div>
                }
              </div>
            </td>
            <td style="background-color: rgba(0,0,0,.05)">
              <shop-entry-edit-fields
                [entry]="positionen[i]"
                [artikel]="entry.artikel"
                [disableDialog]="true"
                [vertreterconfig]="vsvc.vertreterconfig"
                (entryChange)="updatePosition(i, $event)"
                [view_only]="!actions"
              ></shop-entry-edit-fields>
            </td>
          </tr>
          @if (!ajax_mode && (msvc.isMobile()|async)) {
            <tr>
              <td colspan="2">
                <table style="width: 100%">
                  @for (fieldname of active_fields; track fieldname) {
                    <tr class="field_{{fieldname}}">
                      <th style="width: 1%; padding-right: 10px">
                        <view-field-label-render [fieldname]="fieldname" mode="table"></view-field-label-render>
                      </th>
                      <td>
                        @if (fieldname == 'bezeichnung') {
                          <a
                            routerLink="/shop/{{entry.view_slug}}/{{entry.artikel.ArtikelNummer}}">
                            <view-field-value-render
                              [artikel]="entry.artikel"
                              [view]="entry.artikel.view"
                              [viewcomp]="this"
                              [fieldname]="fieldname"
                              mode="table"
                            ></view-field-value-render>
                          </a>
                          @if (entry.importHinweisOption) {
                            <svg-icon style="padding-left: 5px; cursor: help"
                                      [matTooltip]="getImportHinweisTooltip(entry.importHinweisOption)">info</svg-icon>
                          }
                        }
                        @if (entry.defect && fieldname == 'bezeichnung') {
                          <span style="color: red; padding-left: 10px; cursor: help"
                                matTooltip="Bitte einen anderen Artikel wählen">DEFEKT</span>
                        }
                        @if (entry.readyToSend == false && fieldname == 'bezeichnung') {
                          <span style="color: red; padding-left: 10px; cursor: help"
                                matTooltip="Bitte alle benötigten Zusatzinformationen ausfüllen">Zusatzinformationen fehlen</span>
                        }
                        @if (entry.gui_importHinweisAbgelehnt && fieldname == 'bezeichnung') {
                          <span style="color: #a15c00; padding-left: 10px">Menge wegen abgelehnter Importbestätigung auf 3 Stück reduziert</span>
                        }
                        @if (fieldname == 'bezeichnung') {
                          <view-field-value-render
                            [artikel]="entry.artikel"
                            [view]="entry.artikel.view"
                            [viewcomp]="this"
                            [fieldname]="'note'"
                            mode="table"
                          >
                          </view-field-value-render>
                          @if (!(active_fields).includes('aktionen_button')) {
                            <view-field-value-render
                              style="display: none"
                              [artikel]="entry.artikel"
                              [fieldname]="'aktionen_button'"
                              [view]="entry.artikel.view"
                              [viewcomp]="this"
                              mode="table"
                            >
                            </view-field-value-render>
                          }
                          @if (!(active_fields).includes('einkaufs_statistik_web_button')) {
                            <view-field-value-render
                              style="display: none"
                              [artikel]="entry.artikel"
                              [fieldname]="'einkaufs_statistik_web_button'"
                              [view]="entry.artikel.view"
                              [viewcomp]="this"
                              mode="table"
                            >
                            </view-field-value-render>
                          }
                        }
                        @if (fieldname != 'bezeichnung') {
                          <view-field-value-render
                            [artikel]="entry.artikel"
                            [view]="entry.artikel.view"
                            [viewcomp]="this"
                            [fieldname]="fieldname"
                            mode="table"
                          ></view-field-value-render>
                        }
                      </td>
                    </tr>
                  }
                  @if (show_category) {
                    <tr>
                      <th>Kategorie</th>
                      <td>
                        {{parent.getViewLabelBySlug(entry.view_slug)}}
                      </td>
                    </tr>
                  }
                  <tr>
                    <th>Einzelpreis</th>
                    <td>
                      {{ (entry.artikel.Kundeneinkaufspreis)|NiceNumber}} &euro;
                    </td>
                  </tr>
                  <tr>
                    <th>Nachliefern</th>
                    <td>
                      <span [matTooltip]="(entry.artikel.Artikelstamm == 'DE' && actions) ? 'Import muss immer nachgeliefert werden' : undefined">
                        <mat-checkbox [(ngModel)]="entry.nachliefern" (change)="entry.dirty = true; updatePosition(i, entry)" [disabled]="!actions || entry.artikel.Artikelstamm == 'DE'"></mat-checkbox>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th>Summe</th>
                    <td>
                      {{ (entry.getSumme() )|NiceNumber}} &euro;
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          }
          @if (cfg.showShopAktionen(entry.artikel) && (visible_artikel_aktionen|async) && (visible_artikel_aktionen|async)[entry.artikel.Artikelstamm+entry.artikel.ArtikelNummer]) {
            <tr
              style="background-color: white">
              <td colspan="2" style="padding: 5px">
                <artikel-aktionen-details [aktionen]="(visible_artikel_aktionen|async)[entry.artikel.Artikelstamm+entry.artikel.ArtikelNummer]"></artikel-aktionen-details>
              </td>
            </tr>
          }
          @if ((visible_artikel_einkaufsstatistik|async) && (visible_artikel_einkaufsstatistik|async)[entry.artikel.Artikelstamm+entry.artikel.ArtikelNummer]) {
            <tr
              style="background-color: white">
              <td colspan="2" style="padding: 5px">
                <einkaufs-statitik-web-details [statistik]="entry.artikel.EinkaufsStatistikWeb"></einkaufs-statitik-web-details>
              </td>
            </tr>
          }
          <tr>
            <td colspan="2" style="text-align: center">
              <span [matTooltip]="entry.addedByHook === true
                ? 'Automatisch hinzugefügte Positionen können nicht dupliziert werden.'
                : 'Position duplizieren'">
                <button (click)="parent.duplicatePosition(entry)" mat-icon-button class="tut_warenkorb_duplicate"
                        [disabled]="entry.addedByHook === true">
                  <svg-icon [color]="entry.addedByHook === true ? 'grey' : 'currentColor'">zeile-duplizieren</svg-icon>
                </button>
              </span>
              <button (click)="addNoteLine(entry)" mat-icon-button class="tut_warenkorb_artnote"
                      matTooltip="Textzeile hinzufügen" [disabled]="entry.note.length >= 28">
                <svg-icon>zeile-einfuegen</svg-icon>
              </button>
              <button onclick="this.blur()" (click)="disableEntryDeleteClick(entry); deletePosition(entry)" [disabled]="entry?.gui_disableDeleteButton == true" mat-icon-button class="tut_warenkorb_artdelete"
                      matTooltip="Position entfernen">
                <svg-icon color="red">loeschen</svg-icon>
              </button>
              <verfuegbarkeits-info-button [artikel]="entry.artikel" [entry]="entry" class="tut_warenkorb_vf"
                                           [supplierId]="supplierId"
                                           [view_slug]="entry.view_slug"></verfuegbarkeits-info-button>
              <feature-block [features]="['ArtikelKlassifizierungSuche']">
                <alternativ-artikel-button [disabled]="entry.artikel.Artikelstamm != 'AT'" [artikel]="entry.artikel" [view_slug]="entry.view_slug" class="tut_warenkorb_alternativ_button"></alternativ-artikel-button>
              </feature-block>
              @if (actions) {
                <merkliste-button [artikel]="entry.artikel" [entry]="entry" [view_slug]="entry.view_slug"></merkliste-button>
              }
            </td>
          </tr>
          @for (line of entry.note; track i; let i = $index) {
            <tr>
              <td>
                <mat-checkbox [disabled]="!actions" [(ngModel)]="entry.print_note_lines[i]" matTooltip="Andrucken"
                              (ngModelChange)="parent.markDirty(entry); parent.positionAutoSave(entry)">
                  @if (msvc.isMobile()|async) {
                    <span>Andrucken</span>
                  }
                </mat-checkbox>
                <mat-form-field style="width: 100%">
                  <input (focusout)="parent.positionAutoSave(entry)" (keydown)="parent.markDirty(entry)" [(ngModel)]="entry.note[i]" matInput maxlength="28"
                         placeholder="Zusatztext {{i+1}}" class="nodeline nodeline_{{entry.id}}">
                  <mat-hint>Maximal 28 Zeichen!</mat-hint>
                </mat-form-field>
              </td>
              <td>
                <button (click)="parent.deleteNoteLine(entry, i)" mat-icon-button matTooltip="Textzeile löschen">
                  <svg-icon>zeile-loeschen</svg-icon>
                </button>
              </td>
            </tr>
          }
        </table>
      </td>
    </tr>
    }
  }
  @if ((visiblePositions|async) !== null) {
    <tr>
      <td colspan="2" style="text-align: center; padding: 10px; font-weight: bold">
        {{positionen.length - (visiblePositions|async).length}} Positionen werden nicht angezeigt
      </td>
    </tr>
  }
}

<!-- Standard Ansicht -->
@if (!ajax_mode && !(msvc.isMobile()|async)) {
  @for (entry of positionen; track entry.id; let i = $index) {
    @if ((visiblePositions|async) === null || (visiblePositions|async)?.includes(entry.id)) {
      <tr>
        <td>
          @if (selectMode) {
            <mat-checkbox [(ngModel)]="selectedEntriesList[entry.id]" (change)="selectedEntriesListChanged()"></mat-checkbox>
          } @else {
            {{i + 1}}
          }

        </td>
        @if (show_category) {
          <td>
            {{parent.getViewLabelBySlug(entry.view_slug)}}
          </td>
        }
        @for (fieldname of active_fields; track fieldname) {
          <td class="field_{{fieldname}}" style="white-space: nowrap">
            @if (fieldname == 'bezeichnung') {
              <a
                routerLink="/shop/{{entry.view_slug}}/{{entry.artikel.ArtikelNummer}}"
                [class.highlightStrong]="entry.artikel.AllreadyOrdered">
                <view-field-value-render
                  [artikel]="entry.artikel"
                  [view]="entry.artikel.view"
                  [viewcomp]="this"
                  [fieldname]="fieldname"
                  mode="table"
                ></view-field-value-render>
              </a>
              @if (cfg.domainconfig?.shop_aktionen_popup && entry.artikel.ArtikelHatAktion && cfg.showShopAktionen(entry.artikel)) {
                <artikel-aktionen-button [artikel]="entry.artikel" [view]="entry.artikel.view" [viewcomp]="this"
                  [popupMode]="true"></artikel-aktionen-button>
              }
              @if (entry.importHinweisOption) {
                <svg-icon style="padding-left: 5px; cursor: help"
                          [matTooltip]="getImportHinweisTooltip(entry.importHinweisOption)">info</svg-icon>
              }
            }
            @if (fieldname == 'bezeichnung') {
              <view-field-value-render
                [artikel]="entry.artikel"
                [view]="entry.artikel.view"
                [viewcomp]="this"
                [fieldname]="'note'"
                mode="table"
              >
              </view-field-value-render>
              @if (!(active_fields).includes('aktionen_button')) {
                <view-field-value-render
                  style="display: none"
                  [artikel]="entry.artikel"
                  [fieldname]="'aktionen_button'"
                  [view]="entry.artikel.view"
                  [viewcomp]="this"
                  mode="table"
                >
                </view-field-value-render>
              }
              @if (!(active_fields).includes('einkaufs_statistik_web_button')) {
                <view-field-value-render
                  style="display: none"
                  [artikel]="entry.artikel"
                  [fieldname]="'einkaufs_statistik_web_button'"
                  [view]="entry.artikel.view"
                  [viewcomp]="this"
                  mode="table"
                >
                </view-field-value-render>
              }
            }
            @if (entry.defect && fieldname == 'bezeichnung') {
              <span style="color: red; padding-left: 10px; cursor: help"
                    matTooltip="Bitte einen anderen Artikel wählen">DEFEKT{{entry.defectInfo ? ' - '+entry.defectInfo:''}}</span>
            }
            @if (entry.readyToSend == false && fieldname == 'bezeichnung') {
              <span style="color: red; padding-left: 10px; cursor: help"
                    matTooltip="Bitte alle benötigten Zusatzinformationen ausfüllen">Zusatzinformationen fehlen</span>
            }
            @if (entry.gui_importHinweisAbgelehnt && fieldname == 'bezeichnung') {
              <span style="color: #a15c00; padding-left: 10px">Menge wegen abgelehnter Importbestätigung auf 3 Stück reduziert</span>
            }
            @if (fieldname != 'bezeichnung') {
              <view-field-value-render
                [artikel]="entry.artikel"
                [view]="entry.artikel.view"
                [viewcomp]="this"
                [fieldname]="fieldname"
                mode="table"
              ></view-field-value-render>
            }
            @if (fieldname == 'bezeichnung' && positionVerfuegbarkeiten && positionVerfuegbarkeiten[entry.id]) {
              <shop-artikel-verfuegbarkeit-inline-info [data]="positionVerfuegbarkeiten[entry.id]"></shop-artikel-verfuegbarkeit-inline-info>
            }
          </td>
        }

        <td style="text-align: right; padding-right: 10px">
          <view-field-value-render [artikel]="entry.artikel" [view]="entry.artikel.view" [mode]="'table'"
                                   fieldname="einkaufspreis"></view-field-value-render>
        </td>
        <td>
          <span [matTooltip]="entry.artikel.Artikelstamm == 'DE' ? 'Import muss immer nachgeliefert werden' : undefined">
            <mat-checkbox [(ngModel)]="entry.nachliefern" (change)="entry.dirty = true; updatePosition(i, entry)" [disabled]="!actions || entry.artikel.Artikelstamm == 'DE'"></mat-checkbox>
          </span>
        </td>
        <td style="width: 1%; white-space: nowrap; padding-right: 10px">
          <shop-entry-edit-fields
            class="tut_warenkorb_menge"
            [entry]="positionen[i]"
            [artikel]="entry.artikel"
            [disableDialog]="true"
            [vertreterconfig]="vsvc.vertreterconfig"
            (entryChange)="updatePosition(i, $event)"
            [view_only]="!actions"
          ></shop-entry-edit-fields>
        </td>
        <td style="text-align: right">
          {{ (entry.getSumme() )|NiceNumber}} &euro;
        </td>
        @if (actions) {
          <td style="white-space: nowrap;">
            <span [matTooltip]="entry.addedByHook === true
              ? 'Automatisch hinzugefügte Positionen können nicht dupliziert werden.'
              : 'Position duplizieren'">
              <button (click)="parent.duplicatePosition(entry)" class="tut_warenkorb_duplicate" mat-icon-button
                      [disabled]="entry.addedByHook === true">
                <svg-icon [color]="entry.addedByHook === true ? 'grey' : 'green'">zeile-duplizieren</svg-icon>
              </button>
            </span>
            <button (click)="addNoteLine(entry)" mat-icon-button class="tut_warenkorb_artnote"
                    matTooltip="Textzeile hinzufügen">
              <svg-icon>zeile-einfuegen</svg-icon>
            </button>
            <button onclick="this.blur()" (click)="disableEntryDeleteClick(entry); deletePosition(entry)" [disabled]="entry?.gui_disableDeleteButton == true" mat-icon-button class="tut_warenkorb_artdelete"
                    matTooltip="Position Entfernen">
              <svg-icon color="red">loeschen</svg-icon>
            </button>
            <verfuegbarkeits-info-button [artikel]="entry.artikel" [entry]="entry" class="tut_warenkorb_vf"
                                         [supplierId]="supplierId"
                                         [view_slug]="entry.view_slug"></verfuegbarkeits-info-button>
            <feature-block [features]="['ArtikelKlassifizierungSuche']">
              <alternativ-artikel-button [disabled]="entry.artikel.Artikelstamm != 'AT'" [artikel]="entry.artikel" [view_slug]="entry.view_slug" class="tut_warenkorb_alternativ_button"></alternativ-artikel-button>
            </feature-block>

            @if (actions) {
              <merkliste-button [artikel]="entry.artikel" [entry]="entry" [view_slug]="entry.view_slug"></merkliste-button>
            }
          </td>
        }
        @if (actions) {
          <td>
            <div style="width: 20px; height: 20px">
              @if (entry.dirty) {
                <div matTooltip="Speichere...">
                  <mat-spinner [diameter]="20"></mat-spinner>
                </div>
              }
            </div>
          </td>
        }
      </tr>
      @if (entry.dtpZusatzdaten && entry.dtpZusatzdaten.length > 0) {
        <tr>
          <td [attr.colspan]="active_fields.indexOf('bezeichnung')+2">
          </td>
          <td  [attr.colspan]="active_fields.length - (active_fields.indexOf('bezeichnung')+2) + (show_category ? 1:0) + 7">
            <div>
              <h3>Zusatzinformationen erforderlich:</h3>
              <shop-dtp-zusatzdaten-editor [warenkorbId]="warenkorb.id" [(entry)]="positionen[i]" [disabled]="!actions || entry.dirty" (dataChanged)="parent.markDirty(positionen[i], 100)"></shop-dtp-zusatzdaten-editor>
            </div>
          </td>
        </tr>
      } @else if (entry.artikel.IstDtpArtikel && entry.dtpZusatzdaten && entry.dtpZusatzdaten.length == 0) {
        <tr>
          <td [attr.colspan]="active_fields.indexOf('bezeichnung')+2">
          </td>
          <td  [attr.colspan]="active_fields.length - (active_fields.indexOf('bezeichnung')+2) + (show_category ? 1:0) + 7">
            <svg-icon>success</svg-icon> Für diesen Artikel sind keine Zusatzinformationen erforderlich.
          </td>
        </tr>
      }
      @for (line of entry.note; track i; let i = $index) {
        <tr>
          <td>
          </td>
          <td>
            <mat-checkbox [disabled]="!actions" [(ngModel)]="entry.print_note_lines[i]" matTooltip="Andrucken" (ngModelChange)="parent.markDirty(entry); parent.positionAutoSave(entry)"></mat-checkbox>
          </td>
          @if (actions) {
            <td [attr.colspan]="show_category ? (active_fields.length+4):(active_fields.length+3)">
              <mat-form-field style="width: 100%">
                <input (focusout)="parent.positionAutoSave(entry)" (keydown)="parent.markDirty(entry)" [(ngModel)]="entry.note[i]" matInput maxlength="28"
                       placeholder="Zusatztext {{i+1}}" class="nodeline nodeline_{{entry.id}}">
                <mat-hint>Maximal 28 Zeichen!</mat-hint>
              </mat-form-field>
            </td>
          }
          @if (!actions) {
            <td [attr.colspan]="show_category ? (active_fields.length+2):(active_fields.length+1)">
              {{entry.note[i]}}
            </td>
          }
          <td colspan="2">
            @if (actions) {
              <div>
                <button (click)="parent.deleteNoteLine(entry, i)" mat-icon-button matTooltip="Textzeile löschen">
                  <svg-icon>zeile-loeschen</svg-icon>
                </button>
              </div>
            }
          </td>
        </tr>
      }

      @if (cfg.showShopAktionen(entry.artikel) && (visible_artikel_aktionen|async) && (visible_artikel_aktionen|async)[entry.artikel.Artikelstamm+entry.artikel.ArtikelNummer]) {
        <tr
          style="background-color: white">
          <td></td>
          <td [attr.colspan]="active_fields.length + 6" style="padding: 5px">
            <artikel-aktionen-details [aktionen]="(visible_artikel_aktionen|async)[entry.artikel.Artikelstamm+entry.artikel.ArtikelNummer]"></artikel-aktionen-details>
          </td>
        </tr>
      }
      @if ((visible_artikel_einkaufsstatistik|async) && (visible_artikel_einkaufsstatistik|async)[entry.artikel.Artikelstamm+entry.artikel.ArtikelNummer]) {
        <tr
          style="background-color: white">
          <td></td>
          <td [attr.colspan]="active_fields.length + 6" style="padding: 5px">
            <einkaufs-statitik-web-details [statistik]="entry.artikel.EinkaufsStatistikWeb"></einkaufs-statitik-web-details>
          </td>
        </tr>
      }
    }
  }
  @if ((visiblePositions|async) !== null) {
    <tr>
      <td [attr.colspan]="active_fields.length + 7" style="text-align: center; padding: 10px; font-weight: bold">
        {{positionen.length - (visiblePositions|async).length}} Positionen werden nicht angezeigt
      </td>
    </tr>
  }
}


@if (positionen.length > 0 && !ajax_mode && !(msvc.isMobile()|async)) {
  <tr class="spacer">
    <td [attr.colspan]="show_category ? (active_fields.length+5):(active_fields.length+4)"></td>
    <td colspan="3"></td>
  </tr>
}
@if (positionen.length > 0 && !ajax_mode && !(msvc.isMobile()|async)) {
  <tr>
    <td [attr.colspan]="show_category ? (active_fields.length+5):(active_fields.length+4)"></td>
    <td class="sumbox">
      {{summe|NiceNumber}} &euro; <br>
    </td>
    @if (actions) {
      <td colspan="2">
      </td>
    }
  </tr>
}

@if (positionen.length > 0 && !ajax_mode && (msvc.isMobile()|async)) {
  <tr class="spacer">
    <td></td>
  </tr>
}
@if (positionen.length > 0 && !ajax_mode && (msvc.isMobile()|async)) {
  <tr>
    <td>
      <div style="text-align: right">
        {{summe|NiceNumber}} &euro; <br>
      </div>
    </td>
  </tr>
}
